/**
 * Remove query params from url
 *
 * @param url  URL to remove query params
 *
 * @returns URL without query params
 */
export function removeQueryParams(url: string): string {
    // biome-ignore lint/complexity/useRegexLiterals: <explanation>
    let _url = url.replace(new RegExp('#', 'g'), '');
    const _i = _url.indexOf('?');
    _url = _i > 0 ? _url.slice(0, _i) : _url;
    _url = _url.endsWith('/') ? _url.slice(0, -1) : _url;
    return _url;
}
